// extracted by mini-css-extract-plugin
module.exports = {"underline":"az_XQ","nextUnderline":"az_YQ","center":"az_ZQ","inlineheader":"az__Q","centerInline":"az_aR","inlineH2orH3":"az_bR","firstText":"az_cR"};